import { NavLink, useNavigate } from "react-router-dom";
import {
  FaHome,
  FaUsers,
  FaCar,
  FaCalendarAlt,
  FaSignOutAlt,
  FaTimes
} from "react-icons/fa";
import { useAuth } from "../context/AuthContext";

const DrivingSchoolSidebar = ({ isOpen, onClose }) => {
  const navigate = useNavigate();
  const { logoutUser } = useAuth();

  const handleLogout = () => {
    logoutUser();
    navigate("/");
    onClose();
  };

  return (
    <div className={`sidebar bg-side text-white ${isOpen ? "open" : ""}`}>
      
      {/* MOBILE CLOSE ICON */}
      <div className="d-lg-none text-end p-3">
        <FaTimes size={22} onClick={onClose} style={{ cursor: "pointer" }} />
      </div>

      <div className="p-3">
        <h4 className="text-center mb-4">Driving School</h4>

        <ul className="nav flex-column">
          <li className="nav-item mb-2">
            <NavLink to="/school/dashboard" className="nav-link text-white" onClick={onClose}>
              <FaHome className="me-2" /> Dashboard
            </NavLink>
          </li>

          <li className="nav-item mb-2">
            <NavLink to="/school/students" className="nav-link text-white" onClick={onClose}>
              <FaUsers className="me-2" /> Our Students
            </NavLink>
          </li>

          <li className="nav-item mb-2">
            <NavLink to="/school/vehicles" className="nav-link text-white" onClick={onClose}>
              <FaCar className="me-2" /> Fleet & Cars
            </NavLink>
          </li>

          <li className="nav-item mb-2">
            <NavLink to="/school/profile" className="nav-link text-white" onClick={onClose}>
              <FaCalendarAlt className="me-2" /> Profile
            </NavLink>
          </li>
        </ul>
      </div>

      <div className="p-3 mt-auto">
        <button
          onClick={handleLogout}
          className="btn btn-danger w-100 d-flex align-items-center justify-content-center"
        >
          <FaSignOutAlt className="me-2" /> Logout
        </button>
      </div>
    </div>
  );
};

export default DrivingSchoolSidebar;
